import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,useParams} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input,Button } from 'antd';
import { ArrowRightOutlined,SearchOutlined, FilterFilled } from '@ant-design/icons';
import { FaAngleDoubleLeft } from "react-icons/fa";

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const { Option } = Select;
const { TextArea } = Input;

const LeadsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const report_no = queryParams.get('report_no');
  const date = queryParams.get('date');
  var venueId = queryParams.get('venue_id');  
  var fixture_id = queryParams.get('fixture_id');  
  if(!venueId){
    var venueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  }
  var month = JSON.parse(localStorage.getItem('month'));
  var year = JSON.parse(localStorage.getItem('year'));
  
  const [loading, setLoading] = useState(true)
  const [venueName, setVenueName] = useState('')
  const [leadData, setLeadData] = useState([])
  const [header, setHeader] = useState([])

  useEffect(() => {
    setLoading(true)
    if(fixture_id)
      getPotentialLeads()
    else
    getLeadsDayByDay()
  }, []); 

  const getPotentialLeads= () => {
    getData(`/eagleeye/getTableData/?report_id=${report_no}&fixture_id=${fixture_id}`)
    .then(response =>{
      setHeader(response.headers)
      setLeadData(response.data)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const  getLeadsDayByDay= () => {
    getData(`/eagleeye/getTableData/?report_id=${report_no}&venue_id=${venueId}&date=${date}`)
    .then(response =>{
      setHeader(response.headers)
      setLeadData(response.data)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const columns = header.map((header, index) => {
    const column = {
      title: header,
      dataIndex: index.toString(),
      key: header,
      align: 'center',
      render: (text) => <span dangerouslySetInnerHTML={{ __html: text }} />
    };

    if (["Name","Mobile No","Mobile","Last Lead Comment"].includes(header)) {
      column.filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8, width: 204 }}>
          <Input
            autoFocus
            placeholder={`Search ${header}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedKeys(value ? [value] : []);
            }}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              type="primary"
              size="small"
              style={{width:90,display:'flex',alignItems:'center'}}
              onClick={() => confirm()}
              icon={<SearchOutlined />}
            >
              Search
            </Button>
            <Button
              type="secondary"
              size="small"
              style={{width:90}}
              onClick={() => {
                clearFilters && clearFilters();
                confirm();
              }}
            >
              Reset
            </Button>
          </div>
        </div>
      );

      column.filterIcon = (filtered) => (
        <SearchOutlined />
      );

      column.onFilter = (value, record) => {
        const cellValue = record[index.toString()];
        const textContent =
          typeof cellValue === "string"
            ? cellValue.replace(/<[^>]*>/g, "")
            : String(cellValue || "");

        return textContent.toLowerCase().includes(value.toLowerCase());
      };
    }

    if (["Source", "Last Lead Status", "Processed By","Current Status"].includes(header)) {
      column.filters = Array.from(
        new Set(
          leadData
            .map(row => {
              const value = row[index];
              const cleanValue = value 
                ? value.replace(/<[^>]*>/g, '').trim()
                : '';
              return cleanValue;
            })
            .filter(value => value && value.trim() !== '')
        )
      )
      .sort()
      .map(value => ({
        text: value,
        value: value,
      }));

      column.onFilter = (value, record) => {
        const cellValue = record[index.toString()];
        const cleanCellValue = cellValue 
          ? cellValue.replace(/<[^>]*>/g, '').trim()
          : '';
        return cleanCellValue === value;
      };

      column.filterIcon = (filtered) => (
        <FilterFilled />
      );
    }

    if (header === "Follow-Up Date" || header === 'Time Added') {
      column.sorter = (a, b) => {
        const aVal = a[index.toString()] || '';
        const bVal = b[index.toString()] || '';
        
        const aDate = moment(aVal, 'DD-MM-YYYYhh:mmA');
        const bDate = moment(bVal, 'DD-MM-YYYYhh:mmA');
        
        return aDate.valueOf() - bDate.valueOf();
      };
    }

    if (header === "Processed On") {
      column.sorter = (a, b) => {
        const aVal = a[index.toString()] || '';
        const bVal = b[index.toString()] || '';
        
        const aTime = moment(aVal, 'HH:mm');
        const bTime = moment(bVal, 'HH:mm');
        
        return aTime.valueOf() - bTime.valueOf();
      };
    }

    return column;
  }); 

  const rowData = leadData.map((row, rowIndex) => {
      const rowObj = {};
      row.forEach((cell, cellIndex) => {
          rowObj[cellIndex] = cell;
      });
      return { key: rowIndex, ...rowObj };
  });

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.Header active={true}>
          <a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/></a>
           <span>Leads List</span>
          <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="table-to-download"
                filename="Leads List"
                sheet="Leads List"
                buttonText="Download"/>
             
        </Styled.Header>

        <div className="recordCount">{rowData.length} records</div>

        <Table
          className="drill-down-table table_container"
          // tableLayout="fixed"
          rowKey="id"
          columns={columns} 
          dataSource={rowData}
          pagination={{ pageSize: 20, showSizeChanger: false}}
         />

        <table style ={{display: 'none'}} id="table-to-download">
          <thead>
            <tr>
              {
                header.map((head)=>(
                  <th>{head.charAt(0).toUpperCase() + head.slice(1).replace(/_/g, ' ')}</th>
                  )
                )
              }
            </tr>
          </thead>
          <tbody>
              {rowData.map((row, rowIndex) => {
                const { key, ...rowWithoutKey } = row;
                return (
                  <tr key={rowIndex}> 
                    {Object.values(rowWithoutKey).map((value, colIndex) => (
                      <td key={colIndex}>{value}</td>
                    ))}
                  </tr>
                )
              })}
          </tbody>
      </table>

      </Styled.MainContainer>

    </Spin>
  );
}

export default LeadsList;